import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Settings, Bell, CreditCard, HelpCircle, ChevronRight, LogOut } from 'lucide-react';
export function Profile() {
  const menuItems = [{
    icon: Settings,
    label: 'Account Settings'
  }, {
    icon: Bell,
    label: 'Notifications'
  }, {
    icon: CreditCard,
    label: 'Payment Methods'
  }, {
    icon: HelpCircle,
    label: 'Help & Support'
  }];
  return <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center p-6 selection:bg-blue-500/30" data-id="element-31">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="w-full max-w-sm mx-auto" data-id="element-32">
        {/* Header */}
        <div className="flex items-center justify-between mb-8" data-id="element-33">
          <Link to="/betiq-dashboard" className="p-2 -ml-2 text-zinc-400 hover:text-white transition-colors rounded-full hover:bg-zinc-900/50" data-id="element-34">
            <ArrowLeft className="w-5 h-5" data-id="element-35" />
          </Link>
          <span className="text-sm font-medium text-zinc-400" data-id="element-36">Profile</span>
          <div className="w-9" data-id="element-37" /> {/* Spacer for centering */}
        </div>

        {/* User Info */}
        <div className="flex flex-col items-center mb-8" data-id="element-38">
          <div className="relative mb-4" data-id="element-39">
            <div className="w-24 h-24 bg-zinc-900 border border-zinc-800 rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(37,99,235,0.15)] overflow-hidden" data-id="element-40">
              <span className="text-2xl font-bold text-white tracking-wider" data-id="element-41">
                CM
              </span>
            </div>
            <div className="absolute bottom-0 right-0 w-6 h-6 bg-blue-600 rounded-full border-2 border-[#0a0a0a] flex items-center justify-center" data-id="element-42">
              <div className="w-2 h-2 bg-white rounded-full" data-id="element-43" />
            </div>
          </div>

          <h1 className="text-2xl font-bold text-white mb-1 tracking-tight" data-id="element-44">
            Carlos M.
          </h1>
          <p className="text-zinc-400 text-sm mb-3" data-id="element-45">carlos@betiq.com</p>

          <div className="px-3 py-1 bg-blue-600/10 border border-blue-500/20 rounded-full" data-id="element-46">
            <span className="text-xs font-semibold text-blue-400 uppercase tracking-wider" data-id="element-47">
              PRO Member
            </span>
          </div>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-3 gap-3 mb-8" data-id="element-48">
          <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-3 text-center" data-id="element-49">
            <p className="text-xs text-zinc-500 mb-1 font-medium" data-id="element-50">Bets</p>
            <p className="text-lg font-bold text-white" data-id="element-51">142</p>
          </div>
          <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-3 text-center" data-id="element-52">
            <p className="text-xs text-zinc-500 mb-1 font-medium" data-id="element-53">Win Rate</p>
            <p className="text-lg font-bold text-white" data-id="element-54">67%</p>
          </div>
          <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-3 text-center" data-id="element-55">
            <p className="text-xs text-zinc-500 mb-1 font-medium" data-id="element-56">Profit</p>
            <p className="text-lg font-bold text-emerald-400" data-id="element-57">+$2,840</p>
          </div>
        </div>

        {/* Menu Items */}
        <div className="bg-zinc-900/30 border border-zinc-800/50 rounded-2xl overflow-hidden mb-8" data-id="element-58">
          {menuItems.map((item, index) => <button key={index} className={`w-full flex items-center justify-between p-4 hover:bg-zinc-800/50 transition-colors ${index !== menuItems.length - 1 ? 'border-b border-zinc-800/50' : ''}`} data-id="element-59">
              <div className="flex items-center gap-3" data-id="element-60">
                <div className="p-2 bg-zinc-900 rounded-lg text-zinc-400" data-id="element-61">
                  <item.icon className="w-4 h-4" data-id="element-62" />
                </div>
                <span className="text-sm font-medium text-zinc-200" data-id="element-63">
                  {item.label}
                </span>
              </div>
              <ChevronRight className="w-4 h-4 text-zinc-600" data-id="element-64" />
            </button>)}
        </div>

        {/* Logout Button */}
        <button className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl border border-red-500/20 text-red-400 text-sm font-semibold hover:bg-red-500/10 transition-colors active:scale-[0.98]" data-id="element-65">
          <LogOut className="w-4 h-4" data-id="element-66" />
          Log Out
        </button>
      </motion.div>
    </div>;
}